<mat-menu #contextMenu="matMenu" [xPosition]="xPosition" [yPosition]="yPosition">
  <a
    mat-menu-item
    href=" https://www.vendasta.com/get-an-instant-demo?utm_source=partner-center&utm_medium=referral&utm_campaign=upgrade-to-starter&utm_content=instant-demo-button"
    target="_blank"
    *ngIf="(isFreePartner$ | async) && (trialActive$ | async) === false && shouldDisplayInstantDemo === true"
  >
    <mat-icon>fast_forward</mat-icon>
    {{ 'HELP_MENU.INSTANT_DEMO' | translate }}
  </a>
  <a *ngIf="supportNumber$ | async as phone" mat-menu-item href="tel:+{{ phone }}">
    <mat-icon>phone</mat-icon>
    {{ phone }}
  </a>
  <a mat-menu-item href="javascript:$zopim.livechat.window.show();">
    <mat-icon>chat</mat-icon>
    {{ 'HELP_MENU.OPEN_LIVE_CHAT' | translate }}
  </a>
  <a
    *ngIf="(trialActive$ | async) === true && accountExecutiveEmail"
    mat-menu-item
    href="mailto:{{ accountExecutiveEmail }}"
  >
    <mat-icon>email</mat-icon>
    {{ 'HELP_MENU.EMAIL_SALES' | translate }}
  </a>
  <a mat-menu-item (click)="openResourceCenter()">
    <mat-icon>import_contacts</mat-icon>
    {{ 'HELP_MENU.RESOURCE_CENTER' | translate }}
  </a>
  <a mat-menu-item href="https://support.vendasta.com/hc/en-us/requests/new" target="_blank">
    <mat-icon>local_play</mat-icon>
    {{ 'HELP_MENU.SUBMIT_A_TICKET' | translate }}
  </a>
  <a mat-menu-item href="https://support.vendasta.com/hc/en-us/requests" target="_blank">
    <mat-icon>history</mat-icon>
    {{ 'HELP_MENU.TICKET_HISTORY' | translate }}
  </a>
</mat-menu>
